<template>
  <div class="social-bar elevation-12" v-if="items && items.length">
    <ul>
      <li v-for="(item, index) in items" :key="index">
        <v-btn @click="getUrl(index)" :color="color" block raised :style="{width: size + 'px'}">
          <mdi-icon :icon="item.icon" size="24" color="#fff" />
        </v-btn>
      </li>
    </ul>
  </div>
</template>
<script>
import MdiIcon from './mdi-icon'

export default {
  name: 'SocialBar',
  components: {
    MdiIcon
  },
  props: [
    'baseColor'
  ],
  data () {
    return {
      items: [], // items
      size: this.$attrs.size || '36', // button width
      state: this.$store.state,
      color: this.$store.state.secondaryColor,
      siteTitle: this.$store.state.meta.siteTitle
    }
  },
  created () {
    this.$http('/static/data/social.json').then(response => {
      this.items = response.data.social
    })
  },
  methods: {
    getUrl (index) {
      const url = this.items[index].url.replace(/{url}/g, 'http://icons.wemakesites.net').replace(/{siteTitle}/g, this.siteTitle)
      window.open(url, '_blank')
    }
  }
}
</script>
<style>
.social-bar ul,
.social-bar li,
.social-bar .btn,
.social-bar .btn.btn--block .btn__content
{
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: initial;
}

.social-bar
{
  position: fixed;
  transform: translatey(-50%);
  top: 50%;
  /*right: -28px;*/
  right: 0;
  z-index: 1000;
  background: #fff;
  padding: 4px 4px 0 4px;
  border-radius: 4px 0 0 4px;
  transition: all 500ms cubic-bezier(0.680, -0.550, 0.265, 1.550);
}

.social-bar:hover
{
  right: 0;
}

.social-bar.social-bar-left
{
  right: auto;
  left: -28px;
}

.social-bar.social-bar-left:hover
{
  left: 0;
}

.social-bar li
{
  padding: 0 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/social-bar.vue